import React from 'react';
import Illustration from './Illustration';
import EkaCareLogo from './EkaCareLogo';
import LoginWithUHI from './LoginWithUHI';
import { track } from '../../tracking';

interface WithLayoutProps {
    isRegistered: string | boolean;
    isError: string | boolean;
    children: React.ReactChild | null;
}

const WithLayout: React.FC<WithLayoutProps> = ({ children }) => {
    return (
        <div className="flex flex-col w-screen h-full bg-white font-lato">
            <div className="grid w-full h-full grid-cols-12">
                <div className="self-center col-span-5 col-start-2 justify-self-center pb-48">
                    <Illustration />
                </div>
                <div className="flex flex-col self-center col-span-4 col-start-8 p-24 space-y-24 bg-white rounded-10 shadow-fluffy-6 ">
                    <div className="self-center">
                        <EkaCareLogo />
                    </div>
                    {children}
                </div>
                <div className="absolute flex self-end space-x-16 bottom-10 left-64 whitespace-nowrap">
                    <div className="cursor-pointer text-actionPrimary font-300 text-14 mb-30">
                        ©Orbi.Health
                    </div>
                    <a
                        href="https://sites.google.com/orbi.health/contact/home"
                        target="_blank"
                        className="cursor-pointer text-actionPrimary font-300 text-14 mb-30"
                    >
                        Contact
                    </a>
                    <a
                        href="https://sites.google.com/orbi.health/terms-of-use/home"
                        target="_blank"
                        className="cursor-pointer text-actionPrimary font-300 text-14 mb-30"
                    >
                        T&amp;C
                    </a>
                    <a
                        href="https://sites.google.com/orbi.health/privacy-policy/home"
                        target="_blank"
                        className="cursor-pointer text-actionPrimary font-300 text-14 mb-30"
                    >
                        Privacy Policy
                    </a>
                    <LoginWithUHI />
                    <a
                        href="https://www.youtube.com/watch?v=3UV3oHKMKsk"
                        target="_blank"
                        className="cursor-pointer text-actionPrimary font-300 text-14 mb-30"
                        onClick={() => track('KNOW_MORE_ABOUT_ABDM')}
                    >
                        Know more about ABDM
                    </a>
                </div>
            </div>
        </div>
    );
};

export default WithLayout;
